module.exports = __webpack_public_path__ + "static/media/Detection_hair@2x.b7f53b1f.png";